export const FontSizes = Array.from({ length: 96 }, (_, i) => {
  const v = String(i + 1);
  return { label: v, key: v } as const;
});

export const NumericalFormatItemsList = [
  { label: "#,###;(#,###);-", key: "#,###;(#,###);-" },
  { label: "#,###0.0;(#,###0.0);-", key: "#,###0.0;(#,###0.0);-" },
  { label: "#,###0.00;(#,###0.00);-", key: "#,###0.00;(#,###0.00);-" },
  { label: "#,###;(#,###);0", key: "#,###;(#,###);0" },
  { label: "#,###0.0;(#,###0.0);0.0", key: "#,###0.0;(#,###0.0);0.0" },
  { label: "#,###0.00;(#,###0.00);0.00", key: "#,###0.00;(#,###0.00);0.00" },
  { label: "# ###;(# ###);-", key: "# ###;(# ###);-" },
  { label: "# ###0.0;(# ###0.0);-", key: "# ###0.0;(# ###0.0);-" },
  { label: "# ###0.00;(# ###0.00);-", key: "# ###0.00;(# ###0.00);-" },
  { label: "# ###;(# ###);0", key: "# ###;(# ###);0" },
  { label: "# ###0.0;(# ###0.0);0.0", key: "# ###0.0;(# ###0.0);0.0" },
  { label: "# ###0.00;(# ###0.00);0.00", key: "# ###0.00;(# ###0.00);0.00" },
  { label: "#,##0_);[Red](#,##0);-", key: "#,##0_);[Red](#,##0);-" },
  { label: "#,##0.0_);[Red](#,##0.0);-", key: "#,##0.0_);[Red](#,##0.0);-" },
  { label: "#,##0.00_);[Red](#,##0.00);-", key: "#,##0.00_);[Red](#,##0.00);-" },
  { label: "#,##0_);[Red](#,##0);0", key: "#,##0_);[Red](#,##0);0" },
  { label: "#,##0.0_);[Red](#,##0.0);0.0", key: "#,##0.0_);[Red](#,##0.0);0.0" },
  { label: "#,##0.00_);[Red](#,##0.00);0.00", key: "#,##0.00_);[Red](#,##0.00);0.00" },
  { label: "# ##0_);[Red](# ##0);-", key: "# ##0_);[Red](# ##0);-" },
  { label: "# ##0.0_);[Red](# ##0.0);-", key: "# ##0.0_);[Red](# ##0.0);-" },
  { label: "# ##0.00_);[Red](# ##0.00);-", key: "# ##0.00_);[Red](# ##0.00);-" },
  { label: "# ##0_);[Red](# ##0);0", key: "# ##0_);[Red](# ##0);0" },
  { label: "# ##0.0_);[Red](# ##0.0);0.0", key: "# ##0.0_);[Red](# ##0.0);0.0" },
  { label: "# ##0.00_);[Red](#  ##0.00);0.00", key: "# ##0.00_);[Red](#  ##0.00);0.00" },
];

export const DateFormatItemsList = [
  { label: "$-en-US]mmm-yy", key: "$-en-US]mmm-yy" },
  { label: "@dd-mmm-yyyy", key: "dd-mmm-yyyy" },
  { label: "mmm-yyyy", key: "mmm-yyyy" },
  { label: "mm-yyyy", key: "mm-yyyy" },
  { label: "yyyy", key: "yyyy" },
  { label: "yy", key: "yy" },
  { label: "dd-mmm-yy", key: "dd-mmm-yy" },
  { label: "mmm-yy", key: "mmm-yy" },
  { label: "mm-yy", key: "mm-yy" },
  { label: "mmm-dd-yyyy", key: "mmm-dd-yyyy" },
  { label: "mmm-dd-yy", key: "mmm-dd-yy" },
  { label: "dd/mmm/yyyy", key: "dd/mmm/yyyy" },
  { label: "mmm/yyyy", key: "mmm/yyyy" },
  { label: "mm/yyyy", key: "mm/yyyy" },
  { label: "dd/mmm/yy", key: "dd/mmm/yy" },
  { label: "mmm/yy", key: "mmm/yy" },
  { label: "mm/yy", key: "mm/yy" },
  { label: "mmm/dd/yyyy", key: "mmm/dd/yyyy" },
  { label: "mmm/dd/yy", key: "mmm/dd/yy" },
];

export const decimalPointsForSharePriceList = [
  { label: "0", key: "0" },
  { label: "0.0", key: "0.0" },
  { label: "0.00", key: "0.00" },
  { label: "0.000", key: "0.000" },
  { label: "0.0000", key: "0.0000" },
  { label: "0.00000", key: "0.00000" },
  { label: "0.000000", key: "0.000000" },
];

export const percentageFormatItemsList = [
  { label: "#,###0%;(#,###0%);-", key: "#,###0%;(#,###0%);-" },
  { label: "0%;(0%);-", key: "0%;(0%);-" },
  { label: "0.0%;(0.0%);-", key: "0.0%;(0.0%);-" },
  { label: "0.00%;(0.00%);-", key: "0.00%;(0.00%);-" },
  { label: "0%;(0%);0%", key: "0%;(0%);0%" },
  { label: "0.0%;(0.0%);0.0%", key: "0.0%;(0.0%);0.0%" },
  { label: "0.00%;(0.00%);0.00%", key: "0.00%;(0.00%);0.00%" },
];

export interface ColorEntry {
  name: string;
  fillColor: string;
  textColor: string;
}

export interface UserOption {
  label: string;
  value: string;
}

export const defaultChartColors: ColorEntry[] = [
  { name: "color1", fillColor: "#4D93D9", textColor: "rgb(0,0,0)" },
  { name: "color2", fillColor: "#93DAA8", textColor: "rgb(0,0,0)" },
  { name: "color3", fillColor: "#F1A983", textColor: "rgb(0,0,0)" },
  { name: "color4", fillColor: "#9882C1", textColor: "rgb(0,0,0)" },
  { name: "color5", fillColor: "#747474", textColor: "rgb(0,0,0)" },
  { name: "color6", fillColor: "#61CBF3", textColor: "rgb(0,0,0)" },
  { name: "color7", fillColor: "#8ED973", textColor: "rgb(0,0,0)" },
  { name: "color8", fillColor: "#404040", textColor: "rgb(0,0,0)" },
  { name: "color9", fillColor: "#A8A8A8", textColor: "rgb(0,0,0)" },
  { name: "color10", fillColor: "#44B3E1", textColor: "rgb(0,0,0)" },
];

export const defaultTableColors: ColorEntry[] = [
  { name: "color1", fillColor: "#C0E6F5", textColor: "rgb(0,0,0)" },
  { name: "color2", fillColor: "#CAECD5", textColor: "rgb(0,0,0)" },
  { name: "color3", fillColor: "#FBE2D5", textColor: "rgb(0,0,0)" },
  { name: "color4", fillColor: "#DFD8EC", textColor: "rgb(0,0,0)" },
  { name: "color5", fillColor: "#D0D0D0", textColor: "rgb(0,0,0)" },
];
